export const uk = {
	COMMON: {
		"in-stock": "В наявності",
		CargoBranch: "Вантажне відділення",
		PUDO: "Пункт",
		PostBranch: "Відділення",
		Postomat: "Поштомат",
		accepted: "В роботі",
		active: "Активний",
		admin: "Адмін",
		allowCustomText: "Дозволити індивідуальний текст",
		allowedCustomText: "Дозволено індивідуальний текст",
		amount: "Кількість",
		appartment: "Квартира",
		apply: "Застосувати",
		area: "Область",
		areaRef: "Id області",
		booked: "Заброньовано",
		branchAddress: "Адреса відділення",
		branchId: "Id відділення",
		branchRef: "Id відділення",
		callback: "Передзвонити",
		cancel: "Скасувати",
		canceled: "Скасовано",
		city: "Місто",
		cityRef: "Id міста",
		clear: "Очистити",
		closed: "Закрито",
		code: "Код",
		collection: "Колекція",
		collections: "Колекції",
		color: "Колір",
		colors: "Кольори",
		comment: "Коментар",
		components: "Компоненти",
		country: "Країна",
		courier: "Курьер",
		created: "Створено",
		createdAt: "Створено",
		credentials: "Облікові дані",
		currency: "Валюта",
		customer: "Клієнт",
		customerHistory: "Історія клієнта",
		customers: "Клієнти",
		deleting: "Видалення",
		deliveryMethod: "Метод доставки",
		deliveryMethodDescription: "Опис методу доставки",
		description: "Опис",
		discount: "Знижка",
		discounted: "Зі знижкою",
		discountedPrice: "Ціна зі знижкою",
		divisionAddress: "Адреса відділення",
		divisionCategory: "Категорія відділення",
		divisionId: "Id відділення",
		divisionName: "Назва відділення",
		draft: "Створення",
		email: "Поштова адреса",
		expired: "Не оплачено",
		fail: "Невдача",
		failure: "Невдача",
		failureReason: "Причина невдачі",
		features: "Особливості",
		file: "Файл",
		filters: "Фільтри",
		finalAmount: "Остаточна сума",
		firstName: "Ім'я",
		generalInfo: "Загальні відомості",
		group: "Згрупувати",
		height: "Висота",
		hex: "Hex",
		history: "Історія",
		hold: "Холд",
		image: "Зображення",
		images: "Зображення",
		inactive: "Неактивний",
		init: "Створення",
		invite: "Запросити",
		invoiceId: "Інвойс id",
		item: "Предмет",
		itemPrototype: "Прототип",
		itemPrototypes: "Прототипи",
		items: "Предмети",
		keywords: "Ключові слова",
		kind: "Категорія",
		kinds: "Категорії",
		language: "Мова",
		lastName: "Прізвище",
		length: "Довжина",
		locale: "Локаль",
		login: "Увійти",
		manager: "Менеджер",
		market: "Ринок",
		material: "Матеріал",
		materials: "Матеріали",
		method: "Спосіб",
		name: "Назва",
		namePlural: "Назва (множ.)",
		no: "Ні",
		noCancel: "Ні, скасувати",
		nonce: "Номер",
		note: "Примітка",
		notifications: "Повідомлення",
		np_box: "Поштомат НП",
		np_brnm: "Нова пошта",
		opened: "Відкрито",
		order: "Замовлення",
		orders: "Замовлення",
		password: "Пароль",
		payment: "Оплата",
		paymentHistory: "Історія оплати",
		paymentMethod: "Метод оплати",
		paymentMethodDescription: "Опис методу оплати",
		phoneNumber: "Номер телефону",
		pickup: "Самовивіз",
		policy: "Політика",
		porch: "Під'їзд",
		postOffice: "Пошта",
		preview: "Попередній перегляд",
		price: "Ціна",
		priceForCustomText: "Ціна за індивідуальний текст",
		pricePolicies: "Цінова політика",
		pricePolicy: "Цінова політика",
		processing: "Обробка",
		products: "Продукти",
		profile: "Профіль",
		prototype: "Прототип",
		publish: "Опублікувати",
		register: "Зареєструватися",
		requested: "У запиті",
		restock: "Поповнити",
		reversed: "Повернено",
		roles: "Ролі",
		save: "Зберегти",
		search: "Пошук",
		settings: "Налаштування",
		shipping: "Доставка",
		shippingHistory: "Історія доставки",
		shippingMethod: "Спосіб доставки",
		shippingMethods: "Способи доставки",
		showOnMainPage: "Відображати на головній сторінці",
		showingOnMainPage: "Відображається на головній сторінці",
		signOut: "Вийти",
		size: "Розмір",
		sizes: "Розміри",
		sku: "SKU",
		sold: "Продано",
		state: "Стан",
		status: "Статус",
		street: "Вулиця",
		subscribeToTelegramBot: "Підписатися на Телеграм Бот",
		subtotal: "Проміжний підсумок",
		success: "Успіх",
		summary: "Резюме",
		tag: "Тег",
		tags: "Теги",
		team: "Команда",
		text: "Текст",
		thumbnail: "Головна",
		total: "Сума",
		translations: "Переклади",
		transparent: "Прозорий",
		type: "Тип",
		updatedAt: "Оновлено",
		user: "Користувач",
		width: "Ширина",
		yes: "Так",
		yesClose: "Так, закрити",
		yesDelete: "Так, видалити",
		yesRefund: "Так, повернути",
		yesReject: "Так, відхилити"
	},
	INPUT: {
		PLACEHOLDER: {
			areaName: "Київська",
			areaRef: "00000000-0000-0000-0000-000000000000",
			branchAddress: "Степана Бандери, 21 №180",
			branchId: "00000000-0000-0000-0000-000000000000",
			cityId: "00000000-0000-0000-0000-000000000000",
			cityName: "Київ",
			cityRef: "00000000-0000-0000-0000-000000000000",
			cityType: "Місто",
			code: "****",
			collection: "Колекція #1",
			color: "Білий",
			deliveryMethodDescription: "НП відділення",
			description: "Акриловий топер",
			divisionAddress: "01001, Україна, Київська область, місто Київ, Незалежності, 1",
			divisionName: "Пункт №935 (до 10 кг): Майдан Незалежності, 1",
			email: "stepan{'@'}bandera.com",
			firstName: "Степан",
			hex: "#ffffff",
			itemPrototype: "Топер #1",
			keywords: "день, народження...",
			kind: "Топер | Топери",
			lastName: "Бандера",
			material: "Білий Акрил",
			note: "Зломана ніжка, склеєний",
			password: "********",
			phoneNumber: "+380501234567",
			search: "Пошук",
			selectCollection: "Виберіть колекцію...",
			selectColor: "Виберіть колір...",
			selectDeliveryMethod: "Виберіть метод доставки...",
			selectDivisionCategory: "Виберіть категорію відділення...",
			selectKind: "Виберіть категорію...",
			selectLanguage: "Виберіть мову...",
			selectMaterial: "Виберіть матеріал...",
			selectSize: "Виберіть розмір...",
			selectTag: "Виберіть тег...",
			sku: "6006006",
			tag: "Розпродаж",
			text: "Солодкі 16"
		},
		areaName: {
			error: {
				required: "Необхідно вказати назву області"
			}
		},
		areaRef: {
			error: {
				required: "Необхідно вказати ref області"
			}
		},
		amount: {
			error: {
				integer: "Сума має бути цілим числом",
				min: "Сума має бути більшою або дорівнювати 1",
				max: "Сума має бути меншою або дорівнювати 100"
			}
		},
		branchAddress: {
			error: {
				required: "Необхідно вказати адресу відділення"
			}
		},
		branchId: {
			error: {
				required: "Необхідно вказати id відділення"
			}
		},
		cityId: {
			error: {
				required: "Необхідно вказати id міста"
			}
		},
		cityName: {
			error: {
				required: "Необхідно вказати назву міста"
			}
		},
		cityRef: {
			error: {
				required: "Необхідно вказати ref міста"
			}
		},
		cityType: {
			error: {
				required: "Необхідно вказати тип населеного пункту"
			}
		},
		name: {
			error: {
				required: "Необхідно вказати назву"
			}
		},
		code: {
			error: {
				required: "Необхідно вказати код"
			}
		},
		color: {
			addOptionText: "Додати колір",
			noItemsText: "Не знайдено жодного кольору"
		},
		collection: {
			addOptionText: "Додати колекцию",
			noItemsText: "Не знайдено жодної колекції"
		},
		divisionCategory: {
			error: {
				required: "Необхідно вказати категорію відділення"
			}
		},
		divisionName: {
			error: {
				required: "Необхідно вказати назву відділення"
			}
		},
		divisionAddress: {
			error: {
				required: "Необхідно вказати адресу відділення"
			}
		},
		hex: {
			error: {
				required: "Необхідно вказати hex",
				hex: "Хибний hex"
			}
		},
		email: {
			error: {
				required: "Необхідно вказати поштову адресу",
				email: "Хибна поштова адреса"
			}
		},
		firstName: {
			error: {
				required: "Необхідно вказати ім'я"
			}
		},
		material: {
			addOptionText: "Додати матеріал",
			noItemsText: "Не знайдено жодного матеріалу",
			error: {
				required: "Необхідно вказати матеріал",
				min: "Виберіть хоча б один матеріал"
			}
		},
		method: {
			error: {
				required: "Необхідно вказати метод доставки"
			}
		},
		methodDescription: {
			error: {
				required: "Необхідно вказати опис методу доставки"
			}
		},
		lastName: {
			error: {
				required: "Необхідно вказати прізвище"
			}
		},
		language: {
			error: {
				required: "Необхідно вказати мову"
			}
		},
		kind: {
			error: {
				required: "Необхідно вказати категорію"
			}
		},
		keywords: {
			title: "Ключові слова (відокремлюються комами)"
		},
		password: {
			error: {
				required: "Необхідно вказати пароль",
				min: "Пароль має містити не менше 8 символів",
				max: "Пароль має містити не більше 64 символів",
				weak: "Пароль занадто слабкий"
			}
		},
		phoneNumber: {
			error: {
				required: "Необхідно вказати номер телефону"
			}
		},
		price: {
			error: {
				required: "Необхідно вказати ціну",
				requiredByCondition:
					"Необхідно вказати ціну, оскільки політика цін не знайдена",
				gt: "Ціна має бути більше або дорівнювати 0.01",
				gte: "Ціна має бути більшою або дорівнювати 0"
			}
		},
		roles: {
			title: "Ролі (відокремлюються комами)",
			error: {
				required: "Необхідно вказати ролі",
				min: "Виберіть хоча б одну роль"
			}
		},
		size: {
			addOptionText: "Додати розмір",
			noItemsText: "Не знайдено жодного розміру",
			error: {
				min: "Виберіть хоча б один розмір",
				required: "Необхідно вказати розмір"
			}
		},
		sku: {
			error: {
				invalid: "Хибний SKU"
			}
		},
		discountedPrice: {
			error: {
				gt: "Ціна зі знижкою має бути більше або дорівнювати 0.01",
				lt: "Ціна зі знижкою має бути меншою за ціну"
			}
		},
		tag: {
			addOptionText: "Додати тег",
			noItemsText: "Не знайдено жодного тегу"
		},
		width: {
			error: {
				gte: "Ширина має бути більшою або дорівнювати 0",
				positive: "Ширина повинна бути позитивним числом"
			}
		},
		height: {
			error: {
				gte: "Висота має бути більшою або дорівнювати 0",
				positive: "Висота повинна бути позитивним числом"
			}
		},
		length: {
			error: {
				gte: "Довжина має бути більшою або дорівнювати 0",
				positive: "Довжина повинна бути позитивним числом"
			}
		},
		telegram: {
			title: "Telegram id",
			error: {
				invalid: "Хибний Telegram id"
			}
		}
	},
	COMPONENTS: {
		APP: {
			DROPZONE: {
				dropFilesToStartUpload: "Перетягніть файли, щоб почати завантаження",
				dropYourImagesHereOr: "Перетягніть свої зображення сюди або ",
				clickToBrowse: "натисніть, щоб переглянути",
				maxSize: "Максимальний розмір 10MB"
			}
		},
		COLLECTIONS: {
			BUTTON_NEW: {
				title: "Створити колекцію"
			},
			CONFIRM_DELETE: {
				title: "Видалити колекцію",
				description:
					"Ви впевнені що бажаєте видалити '{collectionName}' колекцію?",
				alert: {
					title: "Колекцію видалено!",
					description: "Ви видалили '{collectionName}'"
				}
			},
			MENU: {
				edit: "Редагувати колекцію",
				delete: "Видалити колекцію"
			},
			MODAL_EDIT: {
				title: "Редагування колекції",
				alert: {
					title: "Деталі колекції змінено!",
					description: "'{collectionName}' колекцію оновлено"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодної колекції"
			}
		},
		COLORS: {
			BUTTON_NEW: {
				title: "Створити колір"
			},
			CONFIRM_DELETE: {
				title: "Видалити колір",
				description: "Ви впевнені що бажаєте видалити '{colorName}' колір?",
				alert: {
					title: "Колір видалено!",
					description: "Ви видалили '{colorName}'"
				}
			},
			MENU: {
				edit: "Редагувати колір",
				delete: "Видалити колір"
			},
			MODAL_EDIT: {
				title: "Редагування кольору",
				alert: {
					title: "Деталі кольору змінено!",
					description: "'{colorName}' колір оновлено"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодного кольору"
			}
		},
		COMMON: {
			TABLE: {
				results: "{resultsToShow} із {total} результатів",
				pagination: "{currentPage} із {pageCount}"
			}
		},
		CUSTOMER_HISTORIES: {
			TABLE: {
				noItemsText: "Не знайдено жодного запису історії клієнта"
			}
		},
		CUSTOMERS: {
			MENU: {
				goto: "Детальніше",
				edit: "Редагувати клієнта"
			},
			MODAL_EDIT: {
				title: "Редагування клієнту",
				alert: {
					title: "Деталі клієнта змінено!",
					description: "'{email}' клієнта оновлено"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодного клієнта"
			}
		},
		ITEM_PROTOTYPES: {
			BUTTON_SEARCH: {
				title: "Пошук за SKU"
			},
			BUTTON_NEW: {
				title: "Створити прототип"
			},
			CONFIRM_DELETE: {
				title: "Видалити прототип",
				description:
					"Ви впевнені що бажаєте видалити '{itemPrototypeName}' прототип?",
				alert: {
					title: "Прототип видалено!",
					description: "Ви видалили '{itemPrototypeName}'"
				}
			},
			MENU: {
				restock: "Додати до наявності",
				edit: "Редагувати прототип",
				delete: "Видалити прототип"
			},
			TABLE: {
				noItemsText: "Не знайдено жодного прототипу"
			}
		},
		ITEMS: {
			ADD_FORM: {
				button: {
					title: "Додати {amount} предмет(ів)"
				}
			},
			CONFIRM_DELETE: {
				title: "Видалити предмет",
				description: "Ви впевнені що бажаєте видалити предмет",
				alert: {
					title: "Предмет видалено!",
					description: "Ви видалили предмет"
				}
			},
			CONFIRM_DELETE_MULTIPLE: {
				title: "Видалити предмет(и)",
				description: "Ви впевнені що бажаєте видалити {count} предмет(ів)?",
				loadingAlert: {
					title: "Видалення {total} предмет(ів)"
				},
				alert: {
					title: "Предмет(и) видалено!",
					description: "Ви видалили {count} предмет(ів)"
				}
			},
			MENU: {
				edit: "Редагувати предмет",
				delete: "Видалити предмет"
			},
			MENU_MULTIPLE: {
				edit: "Редагувати {count} предмет(и)",
				delete: "Видалити {count} предмет(и)"
			},
			TABLE: {
				noItemsText: "Не знайдено жодного предмету"
			}
		},
		KINDS: {
			BUTTON_NEW: {
				title: "Створити категорію"
			},
			CONFIRM_DELETE: {
				title: "Видалити категорію",
				description: "Ви впевнені що бажаєте видалити '{kindName}' категорію?",
				alert: {
					title: "Категорію видалено!",
					description: "Ви видалили '{kindName}'"
				}
			},
			MENU: {
				edit: "Редагувати категорію",
				delete: "Видалити категорію"
			},
			MODAL_EDIT: {
				title: "Редагування категорії",
				alert: {
					title: "Деталі категорії змінено!",
					description: "'{kindName}' категорію оновлено"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодної категорії"
			}
		},
		LAYOUT: {
			SIDE: {
				TEAM: {
					title: "Ваша команда",
					INVITE: {
						title: "Запросити до команди"
					}
				}
			}
		},
		MATERIALS: {
			BUTTON_NEW: {
				title: "Створити матеріал"
			},
			CONFIRM_DELETE: {
				title: "Видалити матеріал",
				description:
					"Ви впевнені що бажаєте видалити '{materialName}' матеріал?",
				alert: {
					title: "Матеріал видалено!",
					description: "Ви видалили '{materialName}'"
				}
			},
			MENU: {
				edit: "Редагувати матеріал",
				delete: "Видалити матеріал"
			},
			TABLE: {
				noItemsText: "Не знайдено жодного матеріалу"
			}
		},
		ORDERS: {
			CONFIRM_CLOSE: {
				title: "Завершити замовлення",
				description: "Ви впевнені що бажаєте завершити замовлення #{nonce}?",
				alert: {
					title: "Замовлення завершено!",
					description: "Ви завершили замовлення #{nonce}"
				}
			},
			CONFIRM_REJECT: {
				title: "Відхилити замовлення",
				description: "Ви впевнені що бажаєте відхилити замовлення #{nonce}?",
				alert: {
					title: "Замовлення відхилено!",
					description: "Ви відхилили замовлення #{nonce}"
				}
			},
			CONFIRM_REFUND: {
				title: "Повернути кошти",
				description:
					"Ви впевнені що бажаєте повернути кошти за замовлення #{nonce}?",
				alert: {
					title: "Кошти повернено!",
					description: "Ви повернули кошти за замовлення #{nonce}"
				}
			},
			MENU: {
				accept: "Прийняти замовлення",
				reject: "Відхилити замовлення",
				close: "Завершити замовлення",
				refund: "Повернути кошти",
				alert: {
					title: "Замовлення прийнято!",
					description: "Ви прийняли замовлення #{nonce}"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодного замовлення"
			}
		},
		PAYMENT_HISTORIES: {
			TABLE: {
				noItemsText: "Не знайдено жодного запису історії платежів"
			}
		},
		PAYMENTS: {
			MENU: {
				goto: "Детальніше"
			}
		},
		PRICE_POLICIES: {
			BUTTON_NEW: {
				title: "Створити цінову політику"
			},
			CONFIRM_DELETE: {
				title: "Видалити цінову політику",
				description:
					"Ви впевнені що бажаєте видалити '{pricePolicy}' цінову політику?",
				alert: {
					title: "Цінову політику видалено!",
					description: "Ви видалили '{pricePolicy}'"
				}
			},
			MENU: {
				edit: "Редагувати цінову політику",
				delete: "Видалити цінову політику"
			},
			TABLE: {
				noItemsText: "Не знайдено жодної цінової політики"
			}
		},
		PROFILE: {
			MODAL_EDIT: {
				alert: {
					title: "Дані профілю змінено!"
				}
			}
		},
		SHIPPING_HISTORIES: {
			TABLE: {
				noItemsText: "Не знайдено жодного запису історії доставки"
			}
		},
		SHIPPINGS: {
			MENU: {
				goto: "Детальніше",
				edit: "Редагувати доставку"
			},
			MODAL_EDIT: {
				title: "Редагування доставки",
				alert: {
					title: "Деталі доставки змінено!",
					description: "Доставку для {firstName} {lastName} оновлено"
				}
			}
		},
		SIZES: {
			BUTTON_NEW: {
				title: "Створити розмір"
			},
			CONFIRM_DELETE: {
				title: "Видалити розмір",
				description: "Ви впевнені що бажаєте видалити '{sizeName}' розмір?",
				alert: {
					title: "Розмір видалено!",
					description: "Ви видалили '{sizeName}'"
				}
			},
			MENU: {
				edit: "Редагувати розмір",
				delete: "Видалити розмір"
			},
			MODAL_EDIT: {
				title: "Редагування розміру",
				alert: {
					title: "Деталі розміру змінено!",
					description: "'{sizeName}' розмір оновлено"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодного розміру"
			}
		},
		TAGS: {
			BUTTON_NEW: {
				title: "Створити тег"
			},
			CONFIRM_DELETE: {
				title: "Видалити тег",
				description: "Ви впевнені що бажаєте видалити '{tagName}' тег?",
				alert: {
					title: "Тег видалено!",
					description: "Ви видалили '{tagName}'"
				}
			},
			MENU: {
				edit: "Редагувати тег",
				delete: "Видалити тег"
			},
			MODAL_EDIT: {
				title: "Редагування тегу",
				alert: {
					title: "Деталі тегу змінено!",
					description: "'{tagName}' тег оновлено"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодного тегу"
			}
		},
		TEAM: {
			MENU: {
				edit: "Редагувати дані користувача"
			},
			MODAL_EDIT: {
				title: "Редагування даних користувача",
				alert: {
					title: "Права доступу користувача змінено!",
					description: "'{email}' користувача оновлено"
				}
			},
			MODAL_INVITE: {
				title: "Запросити користувача",
				alert: {
					title: "Запрошення надіслано!"
				}
			},
			TABLE: {
				noItemsText: "Не знайдено жодного співробітника"
			}
		},
		TRANSLATION: {
			TABLE: {
				noItemsText: "Не знайдено жодного перекладу"
			}
		}
	},
	PAGES: {
		COMPONENTS: {
			COLORS: {
				COLOR: {
					translations: {
						description: "Список перекладів для даного кольору"
					}
				},
				CREATE: {
					title: "Створення нового кольору",
					generalInfo: {
						description: "Заповніть деталі кольору"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Створено новий колір!",
						description: "'{colorName}' колір створено"
					}
				}
			},
			KINDS: {
				KIND: {
					translations: {
						description: "Список перекладів для даної категорії"
					}
				},
				CREATE: {
					title: "Створення нової категорії",
					generalInfo: {
						description: "Заповніть деталі категорії"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Створено нову категорію!",
						description: "'{kindName}' категорію створено"
					}
				}
			},
			MATERIALS: {
				MATERIAL: {
					translations: {
						description: "Список перекладів для даного матеріалу"
					},
					colors: {
						description: "Кольори, використані в матеріалі"
					}
				},
				CREATE: {
					title: "Створення нового матеріалу",
					generalInfo: {
						description: "Заповніть деталі матеріалу"
					},
					colors: {
						description: "Додайте один або декілька кольорів"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Створено новий матеріал!",
						description: "'{materialName}' матеріал створено"
					}
				},
				EDIT: {
					MATERIAL: {
						title: "Редагування матеріалу",
						generalInfo: {
							description: "Заповніть деталі матеріалу"
						},
						colors: {
							description: "Додайте один або декілька кольорів"
						},
						preview: {
							description: "Зручний спосіб переглянути все разом"
						},
						alert: {
							title: "Деталі матеріалу змінено!",
							description: "'{materialName}' матеріал оновлено"
						}
					}
				}
			},
			SIZES: {
				CREATE: {
					title: "Створення нового розміру",
					generalInfo: {
						description: "Заповніть деталі розміру"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Створено новий розмір!",
						description: "'{sizeName}' розмір створено"
					}
				}
			}
		},
		CUSTOMERS: {
			CUSTOMER: {
				orders: {
					title: "Замовлення ({count})",
					description: "Список замовлень замовника"
				},
				customerHistory: {
					description: "Список останніх змін інформації про клієнта"
				}
			},
			INDEX: {
				description: "Перегляньте клієнтів магазину {companyName}"
			}
		},
		ORDERS: {
			ORDER: {
				shipping: {
					description: "Відомості про одержувача"
				},
				payment: {
					description: "Деталі оплати"
				},
				customer: {
					description: "Клієнт, який зробив замовлення"
				}
			},
			INDEX: {
				description: "Перегляньте замовлення магазину {companyName}"
			}
		},
		PAYMENTS: {
			PAYMENT: {
				paymentHistory: {
					description: "Список останніх змін платіжної інформації"
				}
			}
		},
		PRICE_POLICIES: {
			EDIT: {
				POLICY: {
					title: "Редагування цінової політики",
					generalInfo: {
						description: "Заповніть деталі цінової політики"
					},
					materials: {
						description: "Додайте один або декілька матеріалів"
					},
					sizes: {
						description: "Додайте один або декілька розмірів"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Деталі цінової політики змінено!",
						description: "'{pricePolicy}' цінову політику оновлено"
					}
				}
			},
			POLICY: {
				materials: {
					description: "Список матеріалів, на які впливає цінова політика"
				},
				sizes: {
					description: "Список розмірів, на які впливає цінова політика"
				}
			},
			CREATE: {
				title: "Створення нового цінової політики",
				generalInfo: {
					description: "Заповніть деталі цінової політики"
				},
				materials: {
					description: "Додайте один або декілька матеріалів"
				},
				sizes: {
					description: "Додайте один або декілька розмірів"
				},
				preview: {
					description: "Зручний спосіб переглянути все разом"
				},
				alert: {
					title: "Створено нову цінову політику!",
					description: "'{pricePolicy}' цінову політику створено"
				}
			},
			INDEX: {
				description:
					"Керуйте загальними цінами, які автоматично встановлюються для нових товарів"
			}
		},
		PRODUCTS: {
			COLLECTIONS: {
				COLLECTION: {
					translations: {
						description: "Список перекладів для даної колекції"
					}
				},
				CREATE: {
					title: "Створення нової колекції",
					generalInfo: {
						description: "Заповніть деталі колекції"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Створено нову колекцію!",
						description: "'{collectionName}' колекцію створено"
					}
				}
			},
			ITEM_PROTOTYPES: {
				EDIT: {
					PROTOTYPE: {
						title: "Редагування прототипу",
						generalInfo: {
							description: "Заповніть деталі прототипу"
						},
						features: {
							description: "Заповніть особливості прототипу"
						},
						materials: {
							description: "Додайте один або декілька матеріалів"
						},
						sizes: {
							description: "Додайте один або декілька розмірів"
						},
						images: {
							description: "Додайте одне або декілька зображень"
						},
						collections: {
							description: "Додайте одну або декілька колекцій"
						},
						tags: {
							description: "Додайте один або декілька тегів"
						},
						preview: {
							description: "Зручний спосіб переглянути все разом"
						},
						alert: {
							title: "Деталі прототипу змінено!",
							description: "'{itemPrototypeName}' прототип оновлено"
						}
					}
				},
				ITEMS: {
					ITEM: {
						order: {
							description: "Замовлення в якому міститься предмет"
						}
					},
					CREATE: {
						title: "Додавання до наявності",
						generalInfo: {
							description: "Заповніть деталі предмету"
						},
						table: {
							title: "Список",
							description: "Предмети які будуть виставлені до наявності"
						},
						preview: {
							description: "Зручний спосіб переглянути все разом"
						},
						loadingAlert: {
							title: "Створення {count} із {total} предметів"
						},
						alert: {
							title: "Створено нові предмети!",
							description: "'{total}' предметів створено"
						}
					},
					EDIT: {
						title: "Редагування {count} предмет(ів)",
						generalInfo: {
							description: "Заповніть деталі предмету"
						},
						preview: {
							description: "Зручний спосіб переглянути все разом"
						},
						loadingAlert: {
							title: "Оновлення {count} із {total} предметів"
						},
						alert: {
							title: "Деталі предмет(ів) змінено!",
							description: "'{total}' предметів оновлено"
						}
					}
				},
				PROTOTYPE: {
					translations: {
						description: "Список перекладів для даного прототипу"
					},
					images: {
						description: "Зображення, використані в прототипі"
					},
					items: {
						description: "Предмети, які використовують прототип"
					},
					materials: {
						description: "Матеріали, використані в прототипі"
					},
					sizes: {
						description: "Розміри, використані в прототипі"
					}
				},
				CREATE: {
					title: "Створення нового прототипу",
					generalInfo: {
						description: "Заповніть деталі прототипу"
					},
					features: {
						description: "Заповніть особливості прототипу"
					},
					materials: {
						description: "Додайте один або декілька матеріалів"
					},
					sizes: {
						description: "Додайте один або декілька розмірів"
					},
					images: {
						description: "Додайте одне або декілька зображень"
					},
					collections: {
						description: "Додайте одну або декілька колекцій"
					},
					tags: {
						description: "Додайте один або декілька тегів"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Створено новий прототип!",
						description: "'{itemPrototypeName}' прототип створено"
					}
				}
			},
			TAGS: {
				CREATE: {
					title: "Створення нового тегу",
					generalInfo: {
						description: "Заповніть деталі тегу"
					},
					preview: {
						description: "Зручний спосіб переглянути все разом"
					},
					alert: {
						title: "Створено новий тег!",
						description: "'{tagName}' тег створено"
					}
				}
			}
		},
		SEARCH: {
			title: "Пошук за SKU"
		},
		SETTINGS: {
			TEAM: {
				INDEX: {
					description: "Керуйте користувачами своєї адмін панелі {companyName}",
					button: {
						title: "Запросити користувача"
					}
				}
			},
			INDEX: {
				description: "Налаштуйте адмін панель {companyName}",
				button: {
					team: {
						description:
							"Керуйте користувачами своєї адмін панелі {companyName}"
					},
					profile: {
						description: "Редагуйте персональні налаштування"
					}
				}
			}
		},
		SHIPPINGS: {
			SHIPPING: {
				shippingHistory: {
					description: "Список останніх змін інформації про доставку"
				}
			}
		},
		LOGIN: {
			alert: {
				description: "Ви увійшли в систему!"
			}
		},
		REGISTER: {
			alert: {
				title: "Ваш обліковий запис створено!",
				description:
					"Вітаємо! Ви щойно створили обліковий запис. Тепер ви можете авторизуватися"
			}
		}
	}
};
